import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { setPageMeta } from "@/lib/api";
import { Logo } from "@/components/Navbar";
import { Splatter } from "@/components/Splatter";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { setPageMeta("Connexion — Tenay Ain-Pression"); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "admin" ? "/admin" : "/compte");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="relative min-h-[80vh] flex items-center justify-center px-4 py-16">
      <Splatter />
      <div className="relative w-full max-w-md rounded-2xl border border-[#222] bg-[#0A0A0A]/90 backdrop-blur-xl p-8">
        <div className="text-center"><Logo className="text-2xl" /></div>
        <h1 className="mt-6 font-heading text-2xl font-bold text-center">Connexion</h1>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form">
          <div><Label>E-mail</Label><Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-black border-white/15 mt-1" required /></div>
          <div><Label>Mot de passe</Label><Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-black border-white/15 mt-1" required /></div>
          {error && <p data-testid="login-error" className="text-sm text-red-400">{error}</p>}
          <Button data-testid="login-submit" type="submit" disabled={loading} className="btn-primary w-full rounded-full py-6 font-bold">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Se connecter"}
          </Button>
        </form>
        <div className="mt-4 flex items-center justify-between text-sm">
          <Link to="/mot-de-passe-oublie" className="text-gray-400 hover:text-[#E6007E]">Mot de passe oublié ?</Link>
          <Link to="/inscription" className="text-[#E6007E] font-bold">Créer un compte</Link>
        </div>
      </div>
    </div>
  );
}
